// extracted by css-extract-rspack-plugin
export default {"Box":"filter-container-module__Box__EUEPK"};